import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { DeliveriesRequestFilters } from 'api/models/Deliveries';
import { QueryKeys } from 'api/models/QueryKeys';

export const useDeliveries = (params: DeliveriesRequestFilters, disabled = false) => {
  const { isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: [QueryKeys.Deliveries, params],
    queryFn: async () => API.deliveries.getDeliveries(params),
    enabled: isAuthenticated && !disabled,
  });
};
